<template>
  <el-row>
    <el-col :span="24">
      <el-form-item label="元素名称数组" prop="eleNames">
        <el-select multiple placeholder="请选择" v-model="eleNames" @change="eleChange" size="small" style="width:37rem">
          <el-option v-for="ele in validEles" :key="ele.id" :label="ele.name" :value="ele.name"></el-option>
        </el-select>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  data() {
    return {
      eleNames: [],
      eles: [],
    };
  },
  computed: {
    validEles() {
      return this.eles.filter(e => e.id != this.value.id)
    }
  },
  watch: {
    value() {
     this.init()
    },
  },
  created() {
    this.$api.Element.query().then((res) => {
      this.eles = res.items;
    });
    this.init()
  },
  methods: {
    init() {
      if (this.value.eleNames) {
        this.eleNames = JSON.parse(this.value.eleNames);
      }
    },
    eleChange() {
      if (this.eleNames && this.eleNames.length) {
        this.value.eleNames = JSON.stringify(this.eleNames)
      } else {
        this.value.eleNames = null
      }
    },
  },
};
</script>
